import { Box, Container, Stack } from '@mui/material'
import { useAuthContext } from 'components/context/AuthProvider'
import React from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'
import { routes } from 'routes/routes'
import { getSafeRedirectPath } from 'utils'
import { canUseSubscriptionShell } from 'features/Subscription/utils'
import { AuthCopyright } from '../AuthCopyright/AuthCopyright'

export function AuthPagesLayout() {
  const { checkIsLoggedIn, user } = useAuthContext()
  const [searchParams] = useSearchParams()
  const redirect = getSafeRedirectPath(searchParams.get('redirect'))

  if (checkIsLoggedIn()) {
    if (redirect) {
      return <Navigate to={redirect} replace />
    }
    if (!canUseSubscriptionShell(user)) {
      return <Navigate to={routes.addSubscription} replace />
    }
    return <Navigate to={routes.journey} replace />
  }

  return (
    <Container component="main" sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        sx={{ maxWidth: 664 }}
      >
        <Stack mt={3} spacing={2} alignItems="center" maxWidth="460px" width="100%">
          <iframe
            title="_"
            width="100%"
            height="250"
            src="https://www.youtube.com/embed/0F0VmD8QfaM"
            frameBorder="0"
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </Stack>

        <Box alignItems="center" width="100%" sx={{ mt: 2, background: 'white', p: 4 }}>
          <Outlet />
        </Box>

        <AuthCopyright />
      </Box>
    </Container>
  )
}
